<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 14:20:04
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:02:02
-->
<template>
  <ux-form
    ref="form"
    :data="formData"
    :colon="true"
    width="400px"
    :rules="rules"
    label-width="56px"
    data-automation="release"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.apiStepOne.name')" prop="groupId">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.addAccessApi.evn')" prop="env">
      <ux-select v-model="formData.env" :options="$opt.env2"></ux-select>
    </ux-form-item>
    <ux-form-item v-if="type === 'release'" :label="$t('HT.apiStepOne.remark')" start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="100"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      // 发布或下线(release-上线; offline-下线)
      type: String,
      default: 'release'
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // api-id
        env: '', // 环境
        remark: '' // 描述
      },
      rules: this.$rul.release(),
      flowList: []
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
